import { enter, leave } from 'el-transition'

export default class Toast {
  constructor(message, options = {}) {
    this.message = message
    this.type = options.type || 'notice'

    this.element = this.buildNode()
    this.panel = this.element.firstElementChild
  }

  show() {
    document.body.appendChild(this.element)
    enter(this.panel).then(() => {
      this.timer = setTimeout(() => this.remove(), 4000)
    })
  }

  remove() {
    leave(this.panel).then(() => {
      this.element.remove()
    })
  }

  close() {
    clearTimeout(this.timer)
    this.remove()
  }

  buildNode() {
    const placeholder = document.createElement('div')
    placeholder.innerHTML = this.#template()
    const node = placeholder.firstElementChild
    node.querySelector('[data-toast-close]').addEventListener('click', () => this.close())
    return node
  }

  #template() {
    return `
      <div class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end z-60">
        <div data-transition-enter="transform ease-out duration-300 transition" data-transition-enter-start="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" data-transition-enter-end="translate-y-0 opacity-100 sm:translate-x-0" data-transition-leave="transition ease-in duration-100" data-transition-leave-start="opacity-100" data-transition-leave-end="opacity-0" class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black/5 overflow-hidden hidden">
          <div class="p-4">
            <div class="flex items-start">
              <div class="shrink-0">${Toast.#templateIcon[this.type]}</div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-sm ${Toast.#templateTextColorClasses[this.type]}">
                  ${this.message}
                </p>
              </div>
              <div class="ml-4 shrink-0 flex">
                <button data-toast-close class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500">
                  <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `
  }

  static #templateTextColorClasses = {
    'notice': 'font-medium text-gray-900',
    'alert': 'font-bold text-red-400'
  }

  static #templateIcon = {
    'notice': `<svg class="h-6 w-6 text-green-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
               </svg>`,
    'alert': `<svg class="h-6 w-6 text-red-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>`
  }
}
